import { render, staticRenderFns } from "./ProjectionInPractise.vue?vue&type=template&id=01917040&"
import script from "./ProjectionInPractise.vue?vue&type=script&lang=ts&"
export * from "./ProjectionInPractise.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectionInPractise.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports